import { render } from "./MerchantTransferModal.vue?vue&type=template&id=5dbc7582&ts=true"
import script from "./MerchantTransferModal.vue?vue&type=script&lang=ts"
export * from "./MerchantTransferModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__